<div class="login-container">
  <div class="header">
    <img src="assets/images/common/logo.png" [alt]="'LogChain' | translate" />
  </div>
  <div class="main-container">
    <div class="login-card align-center-item">
      <div class="header-cart mb-5">
        <div class="top">
          <div class="left">{{'Welcome to' | translate}} <b>Log</b>Chain!</div>
          <div class="right">{{ getToday() }}</div>
        </div>
        <div class="title text-center mt-3">{{'Two Factor Authentication' | translate}}</div>
        <div *ngIf="user" class="sub-title text-center">
          {{'Please confirm your phone number by enter code sent via SMS' | translate}}
        </div>
        <div *ngIf="user && phoneNumber" class="sub-title text-center">
          {{ "A code has been sent to " | translate }}{{ phoneNumber | hidePhone }}
        </div>
        <ngb-alert
          class="mt-3"
          *ngIf="errorMsg != ''"
          [type]="'danger'"
          [dismissible]="false"
          >{{ errorMsg }}
        </ngb-alert>
      </div>
      <form [formGroup]="confirmForm">
        <div class="form-group">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              formControlName="code"
              [max]="6"
              [min]="6"
              required
              mask="000000"
              placeholder="Enter SMS Code"
            />
          </div>
          <div class="sub-title text-right">
            {{"Didn't receive SMS code?" | translate}}
            <u
              class="resend-code"
              [class.disabled]="disableResend"
              (click)="resendCode()"
              >{{'Resend' | translate}}</u
            >
          </div>
          <!-- <small *ngIf="confirmFormControls.code.touched && confirmFormControls.code.invalid"
              class="form-text text-danger">{{getPasswordErrorMessage()}}</small> -->
        </div>
        <div class="btn-group gap-1">
          <button
            type="button"
            class="btn btn-secondary mr-3"
            (click)="backToLogin()"
          >
            {{'Go back' | translate}}
          </button>
          <button
            [disabled]="confirmForm.invalid"
            class="btn btn-primary btn-block"
            (click)="submitForm()"
          >
            <span *ngIf="!isLoading">{{
              "Confirm" | translate | uppercase
            }}</span>
            <div *ngIf="isLoading" class="spinner-border" role="status"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
